import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
// import { EventStandCalendarPage } from '../event-stand-calendar/event-stand-calendar';
import { EventShowCaseMapComponent } from '../../components/event-show-case-map/event-show-case-map';
import { AuthData } from '../../providers/auth';
import { UserData } from '../../providers/user';
import { EventProfilePage } from '../event-profile/event-profile';

@Component({
  selector: 'page-event-stand-detail',
  templateUrl: 'event-stand-detail.html',
})
export class EventStandDetailPage {
  client;
  event;
  data;

  constructor(public navCtrl: NavController, public navParams: NavParams, public modal: ModalController, public auth: AuthData, public userProvider:UserData) {
    this.client = this.navParams.get("client");
    this.event = this.navParams.get("event");
    this.data = this.navParams.get("data");

    console.log("Client: ", this.client);
    console.log("Event: ", this.event);
    console.log("Data: ", this.data);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventStandDetailPage');
  }

  // openCalendar(){
  //   if (!this.auth.getUser().isAnonymous) {
  //           this.userProvider.getProfile(this.client, this.auth.getUser())
  //           .then((user:any) => {
  //               setTimeout(() => {
  //                 this.navCtrl.push(EventStandCalendarPage,{client:this.client, event:this.event, data:this.data, user:user});
  //               }, 300);
  //           })
  //           .catch(() => {
  //               this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
  //           });
  //           } else {
  //           this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
  //           }
  // }

  openMap(){
    this.navCtrl.push(EventShowCaseMapComponent, {'dataShowcase': this.data,"event":this.event });
  }
 

}



// WEBPACK FOOTER //
// ./src/pages/event-stand-detail/event-stand-detail.ts